import { render, staticRenderFns } from "./NotificationRuleContacts.vue?vue&type=template&id=aa857b00"
import script from "./NotificationRuleContacts.vue?vue&type=script&lang=ts"
export * from "./NotificationRuleContacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports